import { render, staticRenderFns } from "./tabla-productos.vue?vue&type=template&id=595634ec&scoped=true&"
import script from "./tabla-productos.vue?vue&type=script&lang=js&"
export * from "./tabla-productos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595634ec",
  null
  
)

export default component.exports